"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogLevel = exports.ProductionOrderStatus = exports.Platform = void 0;
var Platform;
(function (Platform) {
    Platform["SiteFlow"] = "SiteFlow";
    Platform["AutomationEngine"] = "AutomationEngine";
})(Platform || (exports.Platform = Platform = {}));
var ProductionOrderStatus;
(function (ProductionOrderStatus) {
    ProductionOrderStatus["Awaiting"] = "Awaiting";
    ProductionOrderStatus["Submitted"] = "Submitted";
    ProductionOrderStatus["InProduction"] = "InProduction";
    ProductionOrderStatus["Failed"] = "Failed";
    ProductionOrderStatus["PartiallyDispatched"] = "PartiallyDispatched";
    ProductionOrderStatus["Dispatched"] = "Dispatched";
    ProductionOrderStatus["Resubmitted"] = "Resubmitted";
    ProductionOrderStatus["Cancelled"] = "Cancelled";
})(ProductionOrderStatus || (exports.ProductionOrderStatus = ProductionOrderStatus = {}));
var LogLevel;
(function (LogLevel) {
    LogLevel["info"] = "info";
    LogLevel["warning"] = "warning";
    LogLevel["error"] = "error";
})(LogLevel || (exports.LogLevel = LogLevel = {}));
